<!-- This button triggers the overlay and is it's origin -->
<button
  (click)="isOpen = !isOpen"
  type="button"
  mat-button
  cdkOverlayOrigin
  class="h-full"
  #trigger="cdkOverlayOrigin"
>
  <mat-icon
    *ngIf="acitveNotifications$ | async; let acitveNotifications"
    [matBadgeHidden]="acitveNotifications.length == 0"
    [matBadge]="acitveNotifications.length"
    matBadgeColor="warn"
    fxLayoutAlign="center center"
    >notifications_active</mat-icon
  >
</button>

<!-- This template displays the overlay content and is connected to the button -->
<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="isOpen = false"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="[
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' }
  ]"
>
  <ng-container *ngIf="service.abpdzNotification$ | async; let notifications">
    <mat-card
      class="mat-elevation-z1"
      style="overflow: hidden; padding: 0; min-width: 400px"
      @expandCollapse
    >
      <div
        class="mat-actions p-2"
        fxLayout="row"
        fxLayoutAlign="space-between center"
      >
        <div class="mat-text px-2">
          <div class="text-xl bold">
            {{ "AbpDz::Notification" | abpLocalization }}
          </div>
          <div class="secondary">
            {{ notifications.length }}
            {{ "AbpDz::Notifications" | abpLocalization }}.
          </div>
        </div>
        <button type="button" [routerLink]="['/audit/nothistory']" mat-icon-button>
          <mat-icon> history</mat-icon>
        </button>
      </div>
      <div class="p-1 container">
        <div
          *ngFor="let notification of notifications; let last = last"
          fxLayout="column"
        >
          <div
            class="mat-hover p-1 notification"
            [class.bold]="notification?.state === 0"
            matRipple
          >
            <mat-icon class="icon" [ngClass]="getClass(notification)">{{
              getIcon(notification)
            }}</mat-icon>
            <div
              style="display: flex; flex-direction: column; flex-grow: 1"
              (click)="markAsRead([notification], true)"
            >
              <div class="name">
                {{ notification.notificationName }}
              </div>
              <span class="time mat-text secondary">
                {{ notification.creationTime | abpTimeAgo }}
              </span>
            </div>
            <button
              *ngIf="false"
              (click)="markAsRead([notification])"
              mat-icon-button
            >
              <mat-icon class="close">close</mat-icon>
            </button>
          </div>
          <span class="mat-divider-v"></span>
        </div>
        <div class="no-notifications" *ngIf="notifications.length === 0">
          <!-- All fine! No notifications right now. -->
          {{ "AbpDz::NoNotification" | abpLocalization }}
        </div>
      </div>
      <div class="mat-actions p-1" fxLayout="row" fxLayoutAlign="center center">
        <div class="action">
          <!-- Mark all as read -->
          <button mat-button (click)="markAsRead(notifications)">
            {{ "AbpDz::MarkAllAsRead" | abpLocalization }}
          </button>
        </div>
      </div>
    </mat-card>
  </ng-container>
</ng-template>
